<!-- 
	ActionEmailVerification
	props: ActionCode
	role: Public -- requires email link to not error
	Called by @/views/AccountActions to verify user email
-->

<template>
	<div class="action-email-verification">
		<div v-if="loading">
			<div class="text-xl pb-4">Please wait...</div>
			<Loading />
		</div>
		<div v-else>
			<div v-if="success && error === null">
				<div class="text-2xl winwin-gold pb-4">
					Thank you for verifiying your email address!
				</div>
				<div class="pb-4">
					Please use your email address and password to login
				</div>
				<router-link to="/">
					<CustomButton @click="formLogin()" id="cb-gold">Login</CustomButton>
				</router-link>
			</div>
			<div v-else class="leading-8">
				<div class="text-2xl uppercase">An error has occured</div>
				<div>Your email verification was unsuccessful.</div>
				<div>
					Please
					<a
						href="mailto:customerservice@winwinstafflottery.ca?subject=Email Verification Error"
						class="winwin-aqua"
						>contact customer service</a
					>
					and reference the error code below:
				</div>
				<div class="text-red-400">{{ error }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import firebase from "firebase";

	import CustomButton from "@/components/CustomButton";
	import Loading from "@/components/Loading";

	export default {
		name: "ActionEmailVerification",
		props: ["actionCode"],
		components: {
			CustomButton,
			Loading,
		},
		data() {
			return {
				error: null,
				success: false,
				loading: true,
			};
		},
		created() {
			const auth = firebase.auth();

			const actionCode = this.$props.actionCode;

			auth
				.applyActionCode(actionCode)
				.then((res) => {
					// if action code is valid then trigger success
					this.success = true;
					this.loading = false;
				})
				.catch((err) => {
					// if action code is invalid then trigger failure
					console.log("ERROR => ", err);

					this.error = err.code;
					this.success = false;
					this.loading = false;
				});
		},
		methods: {
			formLogin: function() {
				// redirect to @/views/Auth with login component active
				this.register = false;
				this.$store.commit("formLogin", this.register);
			},
		},
	};
</script>
